import React from 'react'
import Button from '../Button'
import { content } from './content'
import {
  IntercomWrapper,
  ButtonWrapper,
  TextWrapper,
  StyledH3,
  Text,
  SmallText,
  Wrapper,
  Column,
} from './styles'
import IntercomIcon from '../../static/images/icons/intercom-webchat.svg'
import { TRACKING_CATEGORIES } from '../../constants/globalStrings'

const ChatDetails = () => (
  <Wrapper>
    <Column>
      <StyledH3 data-testid="chat-title">{content.chatTitle}</StyledH3>
      <IntercomWrapper>
        <img
          src={IntercomIcon}
          alt="Intercom icon"
          id="intercom_launcher"
          data-testid="intercom-icon"
        />
        <div>
          <Text data-testid="intercom-text">{content.chatCtaPrompt}</Text>
          <Text data-testid="webchat-hours-text">
            {content.chatOpeningHours}
          </Text>
        </div>
      </IntercomWrapper>
      <TextWrapper>
        <SmallText data-testid="webchat-info-text">
          {content.waitTimesAndOutsideOpeningTimes}
        </SmallText>
      </TextWrapper>
    </Column>
    <Column>
      <StyledH3 bottomMargin data-testid="email-title">
        {content.emailTitle}
      </StyledH3>
      <Text data-testid="email-text">{content.emailText}</Text>
      <ButtonWrapper>
        <Button
          href="mailto:h9a446hk@smarty.intercom-mail.com"
          level="tertiary"
          data-item-category={TRACKING_CATEGORIES.CONTACT}
          data-item-name={content.dataItemName}
          data-testid="email-button"
        >
          {content.ctaText}
        </Button>
      </ButtonWrapper>
    </Column>
  </Wrapper>
)

export default ChatDetails
